var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.switchPlay}},[_c('video',{ref:"localVideo",staticStyle:{"width":"100%","height":"100%","object-fit":"contain"},attrs:{"autoplay":"","muted":""},domProps:{"muted":true}})])}
var staticRenderFns = []

export { render, staticRenderFns }